import React from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { Button, Ripple, Img } from "arv-reactcomponents";
import UserId from "../UserId";
import staticEndpoints from "../../../api/endPoints/staticEndpoints";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import { blackboltConfig } from "../../../constants";

@inject("LoginStore")
@observer
class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.userId = props.LoginStore.userId;
    this.userIdFields = null;
    this.onSubmit = this.onSubmit.bind(this);
    this.showLoginView = this.showLoginView.bind(this);
    this.showRegisterView = this.showRegisterView.bind(this);
  }
  componentDidMount() {
    const invalidInput = document.querySelector(".nw-frgt-form input");
    if (invalidInput) {
      setTimeout(() => {
        invalidInput.focus();
      });
    }
  }
  onSubmit(e) {
    e.preventDefault();
    const invalidInput = document.querySelector(
      ".nw-frgt-form input.is-invalid",
    );
    if (invalidInput) {
      invalidInput.focus();
    }
    const { userId, inputType } = this.userIdFields.state;
    if (this.userIdFields.state.isUserIdValid) {
      Analytics.trackEvent({
        action: Event.action.FORGOT_PASSWORD_ATTEMPT,
        category: Event.category.LOGIN,
        label: inputType,
      });
      this.props.LoginStore.forgotPasswordAction(userId, blackboltConfig[inputType]);
    }
  }
  get checkIsFormValid() {
    return this.props.LoginStore.authError ? "" : "nwc-hidden";
  }
  get isShowLoader() {
    return this.props.LoginStore.loader ? "" : "nwc-hidden";
  }
  showLoginView(e) {
    e.preventDefault();
    Analytics.trackEvent({
      action: Event.action.LOGIN_CLICK,
      category: Event.category.LOGIN,
    });
    this.props.LoginStore.changeView("login");
  }
  showRegisterView(e) {
    e.preventDefault();
    Analytics.trackEvent({
      action: Event.action.REGISTER_CLICK,
      category: Event.category.LOGIN,
      label: Event.label.getSource("home"),
    });
    this.props.LoginStore.changeView("register");
  }
  render() {
    return (
      <div className="nw-login-container">
        <div className="nw-login-heading">
          <h1 className="nw-login-title">forgot your password</h1>
        </div>
        <div className="nw-forgotpassword-img">
          <Img
            className="nw-fpIconImg"
            src={staticEndpoints.fpImage}
            alt="forgot password"
          />
        </div>
        <form className="nw-form nw-frgt-form" onSubmit={this.onSubmit}>
          <UserId
            className="nw-login-input nw-grgt-userid"
            placeholder="Enter Your Email-ID or Phone Number"
            name="text"
            value={this.userId}
            ref={values => {
              this.userIdFields = values;
            }}
          />
          <Ripple className="nwc-ripple-light">
            <Button
              type="submit"
              className="nwc-btn-primary nw-login-btn nw-grgt-submitbtn"
              onClick={this.onSubmit}
            >
              SUBMIT
              <div className={`nw-login-loader ${this.isShowLoader}`}>
                <Img
                  className="nw-loader"
                  src="//static.nnnow.com/client/assets/images/icon/loader.gif"
                  alt="loader"
                />
              </div>
            </Button>
          </Ripple>
          <span className={`nw-login-error ${this.checkIsFormValid}`}>
            {this.props.LoginStore.authErrorMsg}
          </span>
          <Button
            className={`nw-register-link nw-login-link nw-grgt-register
            ${this.checkIsFormValid}`}
            onClick={this.showRegisterView}
          >
            Create Account
          </Button>
          <Button
            className="nw-login-link nw-grgt-home"
            onClick={this.showLoginView}
          >
            Back to login
          </Button>
        </form>
      </div>
    );
  }
}
ForgotPassword.wrappedComponent.propTypes = {
  LoginStore: PropTypes.shape({
    authError: PropTypes.bool.isRequired,
    authErrorMsg: PropTypes.string.isRequired,
    forgotPasswordAction: PropTypes.func,
    changeView: PropTypes.func.isRequired,
    userId: PropTypes.string,
    loader: PropTypes.bool.isRequired,
  }).isRequired,
};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/component/Login/ForgotPassword/index.js